import {animateByClass} from "../../Library/Animation.js";

export const removeDeletedAutomation = async (event) => {
    const button = event.detail.elt;

    if (!button.classList.contains('delete-automation')) {
        return;
    }

    if (!event.detail.successful) {
        return;
    }

    const automation = button.closest('.automation');

    await animateByClass(automation, 'remove-automation-animation');

    automation.remove();
};
